import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class MajorUpdateIcon extends BaseIcon {

  getChildren = () => {
    const color = this.getColor() === 'currentColor' ? '#2e3f58' : this.getColor()
    return [
      <path data-name="major update icon" d="M16.714 18H1.285A1.287 1.287 0 0 1 0 16.714V6.428h7.715v2.571A1.288 1.288 0 0 0 9 10.29a1.287 1.287 0 0 0 1.285-1.286V6.433H18v10.286A1.287 1.287 0 0 1 16.714 18Zm-6.428-3.857v1.286h5.143v-1.286Zm7.714-9h-7.714V0H14.564a.873.873 0 0 1 .865.762l2.57 4.383Zm-10.285 0H0L2.571.758a.877.877 0 0 1 .866-.762h4.277v5.141Z" fill={color}/>
    ]
  }
  getViewBox = () => '0 0 18 18.005'
}
